document.addEventListener('DOMContentLoaded', () => {
  let deferredPrompt = null;
  const installBanner = document.getElementById('pwa-install-banner');
  const installActionBtn = document.getElementById('pwa-install-action-btn');
  const notNowBtn = document.getElementById('pwa-not-now-btn');
  const dismissBtn = document.getElementById('pwa-dismiss-btn');
  const instructionText = document.getElementById('pwa-instruction-text');

  if (!installBanner) return;

  // Helper: check if PWA is already installed or running in standalone mode
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
  if (isStandalone) return;

  // Helper: check if user has dismissed the popup recently (within the last 7 days)
  const dismissedUntil = localStorage.getItem('rbs_pwa_dismissed_until');
  if (dismissedUntil && Date.now() < parseInt(dismissedUntil, 10)) {
    return;
  }

  // Detect OS and specific browsers
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/i.test(ua);
  const isSamsungBrowser = /SamsungBrowser/i.test(ua);
  
  // WebView / In-App browser check (FB, Instagram, Google App, etc.)
  const isWebView = /FBAN|FBAV|Instagram|Twitter|GoogleApp|GSA|Messenger/i.test(ua) || 
                    (isIOS && !/Safari/i.test(ua) && !/CriOS/i.test(ua) && !/FxiOS/i.test(ua) && !/EdgiOS/i.test(ua));

  // If inside an in-app browser like Instagram, completely skip PWA prompts to avoid UI interference
  if (isWebView) return;

  // Determine browser type on iOS
  const isIOSSafari = isIOS && /Safari/i.test(ua) && !/CriOS/i.test(ua) && !/FxiOS/i.test(ua) && !/EdgiOS/i.test(ua);
  const isIOSChrome = isIOS && /CriOS/i.test(ua);
  const isIOSOtherBrowser = isIOS && (/FxiOS/i.test(ua) || /EdgiOS/i.test(ua));

  // Show customized PWA guidance based on browser
  function showCustomBanner() {
    if (isWebView) {
      // WebView / In-App webview layout
      instructionText.innerHTML = `To install our Web App: Tap the menu button and select <strong>'Open in Safari'</strong> or <strong>'Open in Chrome'</strong> to add ReBuySell to your home screen.`;
      if (installActionBtn) installActionBtn.style.display = 'none';
      if (notNowBtn) notNowBtn.textContent = 'Got It';
    } else if (isIOS) {
      // iOS browsers
      if (isIOSSafari) {
        instructionText.innerHTML = `To install ReBuySell App: Tap the share button <span style="font-size:1.1rem; line-height:1; display:inline-block; vertical-align:middle; margin-inline: 2px;">⎋</span> (bottom of screen) and select <strong>'Add to Home Screen'</strong>.`;
      } else if (isIOSChrome) {
        instructionText.innerHTML = `To install ReBuySell App: Tap the share button in the address bar (top right) and select <strong>'Add to Home Screen'</strong>.`;
      } else {
        instructionText.innerHTML = `To install ReBuySell App: Tap the browser share menu and select <strong>'Add to Home Screen'</strong>.`;
      }
      if (installActionBtn) installActionBtn.style.display = 'none';
      if (notNowBtn) notNowBtn.textContent = 'Got It';
    } else if (isAndroid && !deferredPrompt) {
      // Android browsers that don't support beforeinstallprompt natively or require fallback instructions
      if (isSamsungBrowser) {
        instructionText.innerHTML = `To install ReBuySell App: Tap the menu button (bottom right) and select <strong>'Add page to'</strong> > <strong>'Home screen'</strong>. If a warning appears, tap <strong>'More details'</strong> > <strong>'Install anyway'</strong>.`;
      } else if (/Firefox/i.test(ua)) {
        instructionText.innerHTML = `To install ReBuySell App: Tap the menu button (three dots in address bar) and select <strong>'Install'</strong> or <strong>'Add to Home Screen'</strong>.`;
      } else {
        instructionText.innerHTML = `To install ReBuySell App: Open the browser settings menu and select <strong>'Add to Home Screen'</strong>.`;
      }
      if (installActionBtn) installActionBtn.style.display = 'none';
      if (notNowBtn) notNowBtn.textContent = 'Got It';
    }

    // Display the banner overlay with slide-in animation
    installBanner.style.display = 'block';
    setTimeout(() => {
      installBanner.classList.add('show');
    }, 150);
  }

  // Intercept beforeinstallprompt for Android browsers (Chrome, Edge, Samsung Internet)
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent default browser install banner
    e.preventDefault();
    deferredPrompt = e;

    // Show custom prompt
    if (installActionBtn) installActionBtn.style.display = 'block';
    if (notNowBtn) notNowBtn.textContent = 'Not Now';
    
    if (isSamsungBrowser) {
      instructionText.innerHTML = 'Install ReBuySell App! <strong>Note:</strong> If Samsung Internet triggers a security warning, tap <strong>"More details"</strong> and click <strong>"Install anyway"</strong> (safe false-positive), or install via <strong>Google Chrome</strong>.';
    } else {
      instructionText.innerHTML = 'Install our official Web App for instant cash quotes, doorstep pickup scheduling, and real-time tracking!';
    }
    
    showCustomBanner();
  });

  // Action Button Handler (Android chrome native install trigger)
  if (installActionBtn) {
    installActionBtn.addEventListener('click', async () => {
      if (!deferredPrompt) return;
      // Show browser's native prompt
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`User installation choice outcome: ${outcome}`);
      deferredPrompt = null;
      hideBanner();
    });
  }

  // Hide Banner utility
  function hideBanner() {
    installBanner.classList.remove('show');
    setTimeout(() => {
      installBanner.style.display = 'none';
    }, 400);
  }

  // Dismiss PWA prompt for 7 days
  function dismissBanner() {
    const oneWeekInMs = 7 * 24 * 60 * 60 * 1000;
    localStorage.setItem('rbs_pwa_dismissed_until', (Date.now() + oneWeekInMs).toString());
    hideBanner();
  }

  if (notNowBtn) notNowBtn.addEventListener('click', dismissBanner);
  if (dismissBtn) dismissBtn.addEventListener('click', dismissBanner);

  // Trigger iOS / Android instructions if they land and installable status is true
  // We run this after 3 seconds so the user is not instantly spammed
  setTimeout(() => {
    // Android is handled by beforeinstallprompt, but iOS/others need manual triggers on load
    if (isIOS || isWebView || (isAndroid && !deferredPrompt && (isSamsungBrowser || /Firefox/i.test(ua)))) {
      showCustomBanner();
    }
  }, 4000);
});
